/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Builder_Stack_EmptyInputs */

const cs_builder_stack_empty = /** @type {(inputs: Builder_Stack_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Přidejte bloky z palety.`)
};

const en_builder_stack_empty = /** @type {(inputs: Builder_Stack_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Add blocks from the palette.`)
};

/**
* | output |
* | --- |
* | "Add blocks from the palette." |
*
* @param {Builder_Stack_EmptyInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const builder_stack_empty = /** @type {((inputs?: Builder_Stack_EmptyInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Builder_Stack_EmptyInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_builder_stack_empty(inputs)
	return cs_builder_stack_empty(inputs)
});